import React, { Component }  from 'react';
import { Link }              from 'react-router';
import Parse                 from 'parse';
import classNames            from 'classnames/bind';
import Utils                 from '../../Utils/Utility';
import Api                   from '../../Utils/api';
import AcctCreation          from '../acct-creation';
import payment               from '../../lib/jquery.payment';
import RegisterRestaurant    from './RegisterRestaurant';
import RegisterPaymentMethod from './RegisterPaymentMethod';
import RegisterSubscription  from './RegisterSubscription';

let wllogo = require('../../../img/wl-logo-blue.png');

export default class RegisterBusiness extends Component {

    constructor(props) {
        super(props);
        this.state = {
            lbName               : '',
            bizName              : '',
            bizAddress           : '',
            bizState             : '',
            bizZipCode           : '',
            bizCity              : '',
            bizPhone             : '',
            bizEmail             : '',
            bizWebSite           : '',
            bizFaxNumber         : '',
            locIdGenerated       : '',
            isMultiLocationBiz   : false,
            isBusinessAccCreated : false,
            isTempDataSaved      : false,
            agreement            : false,
            res : {
                lbName               : '',
                resName              : '',
                resAddress1          : '',
                resAddress2          : '',
                resState             : '',
                resZipCode           : '',
                resCity              : '',
                resPhone             : '',
                resWebsite           : '',
            },
            bill : {
                accountHolderName : '',
                routingNumber     : '',
                accountNumber     : '',
                planType          : { web : true, webPlusMobile : false },
                subscriptionType  : 'monthly'
            },
            bankAccountError    : false,
            bankAccountErrorMsg : ""
        };

        this._bind(
            'changeLbName'             , 'changeBizName'              , 'changeBizAddress1'        ,
            'changeBizAddress2'        , 'changeBizState'             , 'changeBizZipCode'         ,
            'changeBizCity'            , 'changeBizEmail'             , 'changeBizPhone'           ,
            'changeBizFaxNumber'       , 'changeBizWebsite'           , 'changeBizLocFlagToSingle' ,
            'changeBizLocFlagToMulti'  , 'handleSubmit'               , 'createBusinessPromise'    ,
            'saveCustomerTempData'     , 'copyBizToRes'               , 'resetResFields'           ,
            'updateChangedResField'    , 'updateChangedBillInfoField' , 'resetBillInfoFields'      ,
            'createStripeBankCustomer' , 'initializeCustomerDetails'  , 'changeAgreement'
        );
    }

    _bind(...methods) {
        methods.forEach( (method) => this[method] = this[method].bind(this) );
    }

    changeAgreement(e) {
         this.setState({agreement:!this.state.agreement});
    }

     //Business fieldsets starts

    changeLbName(e) {
        this.setState({ lbName : e.target.value });
    }

    changeBizName(e) {
         this.setState({ bizName : e.target.value });
    }

    changeBizAddress1(e) {
         this.setState({ bizAddress1 : e.target.value });
    }

    changeBizAddress2(e) {
         this.setState({ bizAddress2 : e.target.value });
    }

    changeBizState(e) {
         this.setState({ bizState : e.target.value });
    }

    changeBizZipCode(e) {
        this.setState({ bizZipCode : e.target.value });
    }

    changeBizCity(e) {
        this.setState({ bizCity : e.target.value });
    }

    changeBizPhone(e) {
        this.setState({ bizPhone : e.target.value });
    }

    changeBizEmail(e) {
        this.setState({ bizEmail : e.target.value });
    }

    changeBizFaxNumber(e) {
         this.setState({ bizFaxNumber : e.target.value });
    }

    changeBizWebsite(e) {
         this.setState({ bizWebSite : e.target.value });
    }

    changeBizLocFlagToSingle(e) {
        this.setState({ isMultiLocationBiz : false });
    }

    changeBizLocFlagToMulti(e) {
        this.setState({ isMultiLocationBiz : true });
    }

    updateChangedResField(fieldName, value) {
        let res        = this.state.res;
        res[fieldName] = value;
        this.setState({res});
    }

    updateChangedBillInfoField(fieldName, value) {
        let bill        = this.state.bill;
        bill[fieldName] = value;
        this.setState({bill});
    }

    resetResFields() {
        let res = {
            lbName               : '',
            resName              : '',
            resAddress1          : '',
            resAddress2          : '',
            resState             : '',
            resZipCode           : '',
            resCity              : '',
            resPhone             : '',
            resWebsite           : ''
        };
        this.setState({ res });
    }

    resetBillInfoFields() {
        let bill = {
            bankName         : '',
            routingNumber    : '',
            accountNumber    : '',
            planType         : {},
            subscriptionType : ''
        };
        this.setState({ bill });
    }

    copyBizToRes() {
        let res = {
           lbName      : this.state.lbName,
           resName     : this.state.bizName,
           resAddress1 : this.state.bizAddress1,
           resAddress2 : this.state.bizAddress2,
           resState    : this.state.bizState,
           resZipCode  : this.state.bizZipCode,
           resCity     : this.state.bizCity,
           resPhone    : this.state.bizPhone,
           resWebsite  : this.state.bizWebSite
        };
        this.setState({ res });
    }

     //Business fieldsets ends

    //Business form submit handler

    createBusinessPromise() {
        let planType = "";
        if (this.state.bill.planType.web) {
            planType = "web";
        } else {
            planType = "webPlusMobile";
        }

        let createParams
        = {
            legalName   : this.state.lbName,
            name        : this.state.bizName,
            faxNumber   : this.state.bizFaxNumber,
            phoneNumber : this.state.bizPhone,
            email       : this.state.bizEmail,
            website     : this.state.bizWebSite,
            isLive      : !TEST_MODE,
            address     : {
                addLine1 : this.state.bizAddress1,
                addLine2 : this.state.bizAddress2,
                city     : this.state.bizCity,
                state    : this.state.bizState,
                zipCode  : this.state.bizZipCode
            },
            subscriptionType : this.state.bill.subscriptionType,
            planType         : planType
        };

        let userId       = Parse.User.current().id;
        let sessionToken = Parse.User.current().getSessionToken();

        return Api.createBusinessDetail(userId, sessionToken, createParams);
    }

    initializeCustomerDetails() {
       let currentUser = Parse.User.current();

        return {
            firstName : currentUser.firstname,
            lastName  : currentUser.lastname,
            email     : currentUser.email,
            phone     : currentUser.phoneNumber
        };
    }

    createStripeBankCustomer() {
        let self = this;

        //if (!this.validateStripe()) {
            //return;
        //}

        /* Create token */
        let bankData = {
            country             : "US",
            currency            : "USD",
            routing_number      : this.state.bill.routingNumber,
            account_number      : this.state.bill.accountNumber,
            account_holder_name : this.state.bill.accountHolderName,
            account_holder_type : "company"
        };

        Stripe.bankAccount.createToken(bankData, function stripeResponseHandler(status, response) {
            if (response.error) {
                self.setState({
                    bankAccountError    : true,
                    bankAccountErrorMsg : response.error.message,
                    showSpinner         : false
                });
            } else {
                let token           = response.id;
                let userDetailPtrId = Parse.User.current().id;
                let sessionToken    = Parse.User.current().getSessionToken();
                let customerId      = (self.state.customerId) || "";
                let customerDetails = self.initializeCustomerDetails();

                Api.createBankCustomerOnStripe
                (userDetailPtrId, sessionToken, customerId, customerDetails, token)
                    .then(
                        (res) => {
                            self.setState({
                                bankAccountError    : false,
                                bankAccountErrorMsg : "",
                                isTempDataSaved      : true,
                                isBusinessAccCreated : true,
                                showSpinner          : false
                            });
                        },
                        (errorRes) => {
                            if (errorRes && errorRes.responseJSON) {
                                self.setState({
                                    bankAccountError    : true,
                                    bankAccountErrorMsg : errorRes.responseJSON.error.message,
                                    showSpinner         : false
                                });
                            }
                        });
            }
        });
    }

    createLocationPromise(bizId) {
        let createParams = {
            lbName      : this.state.res.lbName,
            name        : this.state.res.resName,
            addLine1    : this.state.res.resAddress1,
            addLine2    : this.state.res.resAddress2,
            state       : this.state.res.resState,
            city        : this.state.res.resCity,
            zipCode     : this.state.res.resZipCode,
            phoneNumber : this.state.res.resPhone,
            url         : this.state.res.resWebsite,
            bizId       : bizId
        };

        let userId       = Parse.User.current().id;
        let sessionToken = Parse.User.current().getSessionToken();

        return Api.createLocationDetail(userId, sessionToken, createParams);
    }

    // Fix this method to generate BusinessDetailPrivate
    saveCustomerTempData(locIdGenerated) {
        let currentUser = Parse.User.current();
        let userId      = currentUser.id;
        let locId       = locIdGenerated;
        return Api.saveCustomerTempData(userId, locId);
    }

    handleSubmit(e) {
        e.preventDefault();

        if (!this.state.agreement) {
            alert('Please select the agreement check box to proceed.');
            return;
        }

        let locIdGenerated = "";
        let bizIdGenerated = "";

        this.setState({ showSpinner : true });

        this.createBusinessPromise()
        .then((businessResult) => {
                let businessDetail = businessResult.data;
                this.setState({
                    businessDetail,
                });
                return businessDetail;
            },
            (error) => {
                this.setState({ showSpinner : false });
            }
        ).then((businessDetail) => {
                let user           = Parse.User.current();
                let BusinessDetail = Parse.Object.extend("BusinessDetail");
                let bizDetail      = new BusinessDetail();
                bizDetail.id       = businessDetail.objectId;
                bizIdGenerated     = businessDetail.objectId;
                user.set("bizId"  , bizDetail);

                return user.save(null);
            },
            (error) => {
                this.setState({ showSpinner : false });
            }
        )
        .then((user) => {
                this.setState({user});
                return this.createLocationPromise(bizIdGenerated);
            },
            (error) => {
                this.setState({ showSpinner : false });
            }
        )
        .then((locResult) => {
                let locId = locResult.data.objectId;
                locIdGenerated = locId;
                this.setState({locIdGenerated});
                return this.saveCustomerTempData(locIdGenerated);
            },
            (error) => {
                this.setState({ showSpinner : false });
            }
        )
        //.then(() => {
                //let user  = Parse.User.current();
                //user.set("processLocId"  , locIdGenerated);
                //return user.save(null);
            //},
            //(error) => {
                //console.log(JSON.stringify(error));
                //this.setState({ showSpinner : false });
            //}
        //)
        //.then(
            //(tD) => {
                    //let userId       = Parse.User.current().id;
                    //let sessionToken = Parse.User.current().getSessionToken();
                    //let params       = {
                        //objectId : bizIdGenerated,
                        //locIds   : [locIdGenerated]
                    //};
                    //return Api.updateBusinessDetail(userId,sessionToken, params);
            //},
            //(error) => {
                //console.log(JSON.stringify(error));
                //this.setState({ showSpinner : false });
            //}
        //)
        .then((data) => {
                //this.createStripeBankCustomer()
                this.setState({
                    showSpinner          : false,
                    isBusinessAccCreated : true
                });
            },
            (error) => {
                console.log("Error in signUp new user:"+JSON.stringify(error));
                this.setState({ showSpinner : false });
            }
        );

    }

    componentWillMount() {
        const currentUser = Parse.User.current();

        if (currentUser) {
            console.log("PARSE_SP_KEY:" + PARSE_SP_KEY);

            Stripe.setPublishableKey(PARSE_SP_KEY);

            let bizPointer  = currentUser.get("bizId");
            if (this.props.businessAdded || bizPointer ) {
                this.setState({
                    isBusinessAccCreated : true
                });
            }
        }
    }

    componentDidMount() {
        //if (this.state.isBusinessAccCreated && !this.state.isTempDataSaved) {
            //this.saveCustomerTempData()
            //.then(
                //(responseData) => {
                    //console.log("Finished:"+responseData.success);
                    //this.setState({
                        //isTempDataSaved : true,
                        //showSpinner     : false
                    //});
                //},
                //(responseData) => {
                    //if (responseData) {
                        //console.log("Error in saving temp user data:"+responseData.error);
                    //}
                //}
            //);
        //}
    }

    render() {
        let  captureLater = (
            <div className="row">
                <div className="col-md-12">
                    <h3 style={{ textAlign : 'center' }}>
                        We will collect details about all of your locations, later.
                    </h3>
                </div>
            </div>
        );

        let RegisterBusinessComp = (
            <div className="container register-pg">
                <div className="row">
                    <div className="col-md-12 text-center">

                        {/*
                            <img
                                className = "center-block img-responsive"
                                src        = {wllogo}
                                alt        = "WirelesslyLinked"
                            />
                        */}

                        <p className="para">
                            Please enter your Business Details below.
                        </p>
                    </div>
                </div>

                {
                    this.state.bankAccountError
                        ? (
                            <div className="alert alert-danger" role="alert">
                                {this.state.bankAccountErrorMsg}
                            </div>
                        )
                        : null
                }

                <form className="form-horizontal" onSubmit={this.handleSubmit}>
                    <div className="row">
                        <div className="col-md-12" style={{ marginLeft : 50, marginRight : 50 }}>
                            <br/>
                            <h3>Business Details</h3>
                            <br/>
                            <fieldset>
                                  {/*<!-- Text input-->*/}
                                  <div className="form-group">
                                    <div className="col-xs-12">
                                        <label htmlFor="lbFName">Legal Business Name</label>
                                        <input
                                            id          = "lbFName"
                                            ref         = "lbName"
                                            type        = "text"
                                            placeholder = "Legal Business Name"
                                            onChange    = {this.changeLbName}
                                            value       = {this.state.lbName}
                                            className   = "form-control"
                                            required
                                            autoFocus
                                        />
                                    </div>
                                  </div>

                                  <div className="form-group">
                                    <div className="col-xs-12">
                                        <label htmlFor="bizName">Business Display Name</label>
                                        <input
                                            id          = "bizName"
                                            ref         = "bizName"
                                            type        = "text"
                                            placeholder = "Business Display Name"
                                            onChange    = {this.changeBizName}
                                            value       = {this.state.bizName}
                                            className   = "form-control"
                                            required
                                        />
                                    </div>
                                  </div>

                                  <div className="form-group">
                                    <div className="col-xs-12">
                                        <label htmlFor="bizAdd1">Address</label>

                                        <input
                                            id          = "bizAdd1"
                                            ref         = "bizAdd"
                                            type        = "text"
                                            placeholder = "Business Address Line 1"
                                            onChange    = {this.changeBizAddress1}
                                            value       = {this.state.bizAddress1}
                                            className   = "form-control"
                                            required
                                        />

                                        <input
                                            id          = "bizAdd"
                                            ref         = "bizAdd"
                                            type        = "text"
                                            placeholder = "Business Address Line 2"
                                            onChange    = {this.changeBizAddress2}
                                            value       = {this.state.bizAddress2}
                                            className   = "form-control"
                                            style       = {{marginTop:10}}
                                        />

                                    </div>
                                  </div>

                                  <div className="form-group">
                                    <div className="col-xs-6">
                                        <label htmlFor="bizState">State</label>
                                        <input
                                            id          = "bizState"
                                            ref         = "bizState"
                                            type        = "text"
                                            placeholder = "State"
                                            onChange    = {this.changeBizState}
                                            value       = {this.state.bizState}
                                            className   = "form-control"
                                            required
                                        />
                                    </div>
                                    <div className="col-xs-6">
                                        <label htmlFor="bizZipCode">Zip Code</label>
                                        <input
                                            id          = "bizZipCode"
                                            ref         = "bizZipCode"
                                            type        = "text"
                                            placeholder = "Zip Code"
                                            onChange    = {this.changeBizZipCode}
                                            value       = {this.state.bizZipCode}
                                            className   = "form-control"
                                            required
                                        />
                                    </div>
                                  </div>

                                  <div className="form-group">
                                    <div className="col-xs-12">
                                        <label htmlFor="bizCity">City</label>
                                        <input
                                            id          = "bizCity"
                                            ref         = "bizCity"
                                            type        = "text"
                                            placeholder = "City"
                                            title       = "City"
                                            onChange    = {this.changeBizCity}
                                            value       = {this.state.bizCity}
                                            className   = "form-control"
                                            required
                                        />
                                    </div>
                                  </div>

                                  <div className="form-group">
                                    <div className="col-xs-12">
                                        <label htmlFor="bizPhone">Phone</label>
                                        <input
                                            id          = "bizPhone"
                                            type        = "tel"
                                            ref         = "bizPhone"
                                            placeholder = "phone"
                                            title       = "XXXXXXXXXX"
                                            onChange    = {this.changeBizPhone}
                                            value       = {this.state.bizPhone}
                                            className   = "form-control"
                                            pattern     = "\d{3}\d{3}\d{4}"
                                            required
                                        />
                                    </div>
                                  </div>

                                  <div className="form-group">
                                    <div className="col-xs-12">
                                        <label htmlFor="email">Email</label>
                                        <input
                                            id          = "email"
                                            ref         = "email"
                                            type        = "email"
                                            placeholder = "Email"
                                            onChange    = {this.changeBizEmail}
                                            value       = {this.state.bizEmail}
                                            className   = "form-control"
                                            required
                                        />
                                    </div>
                                  </div>

                                  <div className="form-group">
                                    <div className="col-xs-12">
                                        <label htmlFor="bizPhone">Fax Number</label>
                                        <input
                                            id          = "bizPhone"
                                            type        = "tel"
                                            ref         = "bizPhone"
                                            placeholder = "Fax Number (optional)"
                                            title       = "XXXXXXXXXX"
                                            onChange    = {this.changeBizFaxNumber}
                                            value       = {this.state.bizFaxNumber}
                                            className   = "form-control"
                                            pattern     = "\d{3}\d{3}\d{4}"
                                        />
                                    </div>
                                  </div>

                                  <div className="form-group">
                                    <div className="col-xs-12">
                                        <label htmlFor="bizWebSite">Website</label>
                                        <input id       = "bizWebSite"
                                            ref         = "bizWebSite"
                                            type        = "text"
                                            placeholder = "Website"
                                            title       = "Website"
                                            onChange    = {this.changeBizWebsite}
                                            value       = {this.state.bizWebSite}
                                            className   = "form-control"
                                            required
                                        />
                                    </div>
                                  </div>

                                  {/*
                                   <div className="form-group">
                                    <div className="col-xs-12">
                                        <label htmlFor="bizLocNum">Business has only one location.</label>
                                        <div className="radio">
                                            <label htmlFor="bizLocRadio">
                                                <input type  = "radio"
                                                    name     = "bizLocRadio"
                                                    id       = "opt1"
                                                    title    = "No of business location"
                                                    onChange = {this.changeBizLocFlagToSingle}
                                                    value    = {!this.state.isMultiLocationBiz}
                                                    checked  = {!this.state.isMultiLocationBiz}
                                                    required autofocus
                                                />
                                                Yes
                                            </label>
                                        </div>
                                        <div className="radio">
                                            <label htmlFor="bizLocRadio">
                                                <input type  = "radio"
                                                    name     = "bizLocRadio"
                                                    id       = "opt2"
                                                    title    = "No of business location"
                                                    onChange = {this.changeBizLocFlagToMulti}
                                                    value    = {this.state.isMultiLocationBiz}
                                                    checked  = {this.state.isMultiLocationBiz}
                                                    required autofocus
                                                />
                                                No
                                            </label>
                                        </div>
                                    </div>
                                  </div>
                                  */}
                              </fieldset>
                          </div>
                        </div>

                        <div>
                            <RegisterRestaurant
                                resObject         = {this.state.res}
                                copyBizToRes      = {this.copyBizToRes}
                                resetResFields    = {this.resetResFields}
                                updateParentField = {this.updateChangedResField}
                            />

                            <RegisterSubscription
                                resetBillInfoFields = {this.resetBillInfoFields}
                                updateParentField   = {this.updateChangedBillInfoField}
                            />
                        </div>

                        <br/>
                        <div className="row">
                            <div className="col-sm-12">
                                <fieldset>
                                      <div className = "form-group">
                                          <div className = "col-xs-12 text-center">
                                              <div className = "checkbox">

                                                  <label className="chk-bx-lbl">
                                                      <input
                                                          type     = "checkbox"
                                                          id       = "agreement"
                                                          ref      = "agreement"
                                                          value    = {this.state.agreement}
                                                          onChange = {this.changeAgreement}
                                                          checked  = {this.state.agreement}
                                                          required
                                                      />

                                                  By checking this box, you acknowledge that you have read <a href="http://freshbytes.io/restaurantagreement" target="_blank">this agreement</a> ,<br/>
                                                  understand it and agree to be bound by its terms and conditions.
                                                  </label>
                                               </div>
                                           </div>
                                      </div>
                                        {
                                            this.state.bankAccountError
                                                ? (
                                                    <div className="alert alert-danger" role="alert">
                                                        {this.state.bankAccountErrorMsg}
                                                    </div>
                                                )
                                                : null
                                        }
                                      <div className="form-group">
                                         <div className="col-xs-12 text-center">
                                             <button className="btn-register-cta">
                                                 {
                                                     this.state.showSpinner ? <i className="fa fa-spinner fa-pulse"></i> : null
                                                 }
                                                 Submit
                                             </button>
                                         </div>
                                      </div>
                                </fieldset>
                            </div>
                        </div>
                    </form>
                </div>
            );

        //return !this.state.isBusinessAccCreated ? RegisterBusinessComp : <AcctCreation showSpinner={this.state.showSpinner}/>;
        return !this.state.isBusinessAccCreated ? RegisterBusinessComp : <RegisterPaymentMethod locId={this.state.locIdGenerated} showSpinner={this.state.showSpinner} /> ;
    }

}





// WEBPACK FOOTER //
// src/components/register/RegisterBusiness.js